import { render, staticRenderFns } from "./comp_ProductCardPrice.vue?vue&type=template&id=4f8271cf&scoped=true&"
import script from "./comp_ProductCardPrice.vue?vue&type=script&lang=js&"
export * from "./comp_ProductCardPrice.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductCardPrice.vue?vue&type=style&index=0&id=4f8271cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8271cf",
  null
  
)

export default component.exports